import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import {
  camel2title,
  checkNumber,
  getPageTitle,
} from "../../common/utils/helper";

function Breadcrumb() {
  let breadcrumbs = useBreadcrumbs();
  if (checkNumber(breadcrumbs?.[breadcrumbs?.length - 1].breadcrumb))
    breadcrumbs.pop();
  if (checkNumber(breadcrumbs?.[breadcrumbs?.length - 1].breadcrumb))
    breadcrumbs.pop();
  return (
    <Row>
      <Col md={6}>
        <h4 className="my-3 title">
          {getPageTitle(breadcrumbs?.[breadcrumbs?.length - 1].breadcrumb)}
        </h4>
      </Col>
      <Col md={6}>
        <div className="breadcrumb-list">
          {breadcrumbs.map(({ match, location, breadcrumb }, index) => {
            return index === breadcrumbs.length - 1 ? (
              <span key={match.pathname}>{camel2title(breadcrumb)}</span>
            ) : (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className={
                  match.pathname === location.pathname
                    ? "breadcrumb-active"
                    : ""
                }
              >
                {camel2title(breadcrumb)} /{" "}
              </NavLink>
            );
          })}
        </div>
      </Col>
    </Row>
  );
}

export default Breadcrumb;
